module.exports = __webpack_public_path__ + "img/astrazeneca.02d56017.png";